// extracted by mini-css-extract-plugin
export default {"main_div":"Navbar_main_div__g95VF","logo":"Navbar_logo__MK0b0","pages":"Navbar_pages__UJQPA","page":"Navbar_page__5pgWC","Login_button":"Navbar_Login_button__N0jVo"};